
export type CaseType = {
    title: string,
    color: string,
    description: string,
    text?: string
};

const caseTypes: { [id: string]: CaseType; } = {
    "Wrong FNSKU": {
        title: "Wrong FNSKU Return", color: "#27AE60",
        description: "The customer returns the wrong item",
        text: "Hello, \nFor the following order, the buyer returned a different unit than what we sent" +
            "\nThe returned unit is not ours and we don't sell it." +
            "\nPlease process full reimbursement.\n\n"
    },
    "Missing Inventory": {
        title: "Lost Warehouse", color: "#27aea3",
        description: "Amazon loses the seller’s inventory after receiving it in their fulfillment center",
        text: "Please investigate lost warehouse for the following units." +
            "\nWe calculated all the relevant transactions and reports. We found That we are owed reimbursements for the following units:" +
            "\n\n"
    },
    "Inventory Discrepancies": {
        title: "Inventory Discrepancies", color: "#AE6027",
        description: "Calculating all inventory transactions to make sure that every unit is available for sale, sold, or reimbursed",
        text: "Please review and reimburse us for the below INVENTORY DISCREPANCY." +
            " As you can see," +
            "the actual ending inventory is less than the expected ending inventory, considering all the ins and outs:" +
            "\nPlease review carefully and reimburse as required.\n\n"
    },
    "FBA Fee": {
        title: "Pick&Pack Fees", color: "#AE2775",
        description: "Seller is overcharged for pick & pack and order handling fees",
        text: 'Hello Amazon, \n\nWhile inspecting the FBA fees charged on our orders in the last 90 days, we detected some overcharges we would like reimbursed:\n'
    },
    "Lost Inbound": {
        title: "Missing Inbound", color: "#aea327",
        description: "While using Amazon’s partnered carrier, the seller’s inventory is lost in transit and does not make it to Amazon’s fulfillment center",
        text: ""
    },
    "Chargebacks": {
        title: "Chargeback", color: "#eb57a1",
        description: "Amazon debits the seller’s account an unauthorized chargeback and never credits the seller for it.",
        text: "Hello Amazon, \nAn unauthorized chargeback has been issued by " +
            "Amazon to the customer however there has been no return and no reimbursement." +
            "\nPlease reimburse us on the refund.\n\n"
    },
    "Restocking fees": {
        title: "Restocking Fee", color: "#695a48",
        description: "FBA orders that were returned after 30 days, for which Amazon owes the seller a 20% restocking fee.",
        text: "Hello Amazon, \nThe following orders have been returned past the 30 days given to the customer.\n" +
            "As they have been returned late, we are owed 20% restocking fee for the units.\n" +
            "Please process.\n\n"
    },
    "Reimbursement Never Processed": {
        title: "Reimbursement Never Processed", color: "#F60E09",
        description: "Amazon promised a reimbursement but never processed it.",
        text: 'Hello Amazon, \nThe following Order Ids were marked as "Reimbursed", but the reimbursement was never processed.\n' +
            "Please process full reimbursement as guaranteed.\n\n"
    },
    "Lost Customer Return": {
        title: "Lost Customer Returns", color: "#e4ec13",
        description: "Confirming all returned units (from buyers) have been returned to the seller’s inventory on the FBA site",
        text: "Hello Amazon, \nPlease confirm that the following orders have indeed returned to our inventory.\n\n"
    },
    "Dimension changes": {
        title: "Product Dimension Change", color: "#b68acb",
        description: "Amazon significantly changed product dimension",
        text: 'Hello Amazon, \n\nFor the following products, it seems that the dimension was changed dramatically without reason.\n' +
            'Please correct the new dimensions and process full reimbursement for past charges.\n\n'
    },
    "Misc Categories": {
        title: "Damaged and Disposed", color: "#c1807c",
        description: "Lost and Damaged units- another version",
        text: ""
    },
    "Extra Unit": {
        title: "Extra Unit", color: "#ebb057",
        description: "Retrieving fees associated with extra units Amazon has removed from the seller’s account.",
        text: 'Hello Amazon, \nThe customer has received another unit, more than was supposed to be sent and we charged FBA fees as well.' +
            "\nAs the extra unit should never been sent in the first place, we require reimbursement on the unit and the fees associated with its shipment.\n" +
            "Please process.\n\n"
    },
    "Wrong Refund": {
        title: "Wrong Refund", color: "#9c9297",
        description: "Amazon refunds the customer for an item that is returned after 45 days.",
        text: "Hello Amazon, \nThe following refunds are higher than they should be." +
            "\nPlease process full reimbursement.\n\n"
    },
    "Wrong Reimbursement": {
        title: "Wrong Reimbursement", color: "#ed6808",
        description: "Amazon processed a low reimbursement",
        text: 'Hello Amazon, \n\The following reimbursements are lower than they should be.\n' +
            'Please process full reimbursement as the unit price is higher.\n\n'
    },
    "Cancelled Shipment": {
        title: "Cancel Shipment Fee", color: "#02224a",
        description: "Canceled shipment fee reimbursements.",
        text: "Hi,\nThe following shipment was canceled and has been charged Amazon partnered carrier fees.\n" +
            "As the shipment never went through, we request a refund of that charge.\nPlease process.\n\n"
    },
    "Damaged and lost Outbound": {
        title: "Damaged Outbound", color: "#8dc09d", description: "Inventory was damaged upon removal order.",
        text: "Hi Amazon,\nThe following was removed and was subsequently damaged by Amazon's carrier.\n" +
            "Please process full reimbursement.\n"
    },
    "default": {
        title: "Default", color: "#27aea3", description: ""
    }
};

export default caseTypes;
